import { Box } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface LightboxCounterProps {
  currentIndex: number;
  totalImages: number;
  isMobile: boolean;
  position?: "top" | "bottom";
}

export const LightboxCounter = ({
  currentIndex,
  totalImages,
  isMobile,
  position = "bottom"
}: LightboxCounterProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        ...(position === "top" ? { top: 0 } : { bottom: 0 }),
        left: 0,
        color: theme.palette.common.white,
        fontSize: isMobile
          ? theme.typography.body1.fontSize
          : theme.typography.h5.fontSize,
        fontWeight: theme.typography.fontWeightMedium,
        zIndex: 30,
        backgroundColor: theme.palette.misc.backdropOverlay,
        padding: isMobile ? "8px 12px" : "10px 16px",
        borderRadius: "4px",
        minWidth: isMobile ? "60px" : "80px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(4px)",
        opacity: 1,
        transition: "opacity 0.2s ease",
        pointerEvents: "auto",
        userSelect: "none",
        WebkitUserSelect: "none",
        WebkitTouchCallout: "none",
        WebkitTapHighlightColor: "transparent"
      }}
    >
      {currentIndex + 1}/{totalImages}
    </Box>
  );
};
